(() => {
  if (window.deliveryDateReady) return;
  window.deliveryDateReady = true;

  const selector = '[data-delivery-date]';
  const attribute = 'Data de entrega pretendida';
  const root = window.Shopify?.routes?.root || '/';

  let selectedDate = null;
  let saveQueue = Promise.resolve();
  let saveFailed = false;
  let refreshNumber = 0;
  let selectionVersion = 0;

  const allowedForms = new WeakSet();

  // Amanhã, contando dias de calendário, na hora de Lisboa.
  function minimumDeliveryDate() {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Lisbon',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).formatToParts(new Date());

    const get = (type) =>
      parts.find((part) => part.type === type).value;

    const tomorrow = new Date(Date.UTC(
      Number(get('year')),
      Number(get('month')) - 1,
      Number(get('day')) + 1
    ));

    return tomorrow.toISOString().slice(0, 10);
  }

  function syncFields() {
    document.querySelectorAll(selector).forEach((field) => {
      field.min = minimumDeliveryDate();

      if (selectedDate === null) {
        selectedDate = field.value;
      }

      if (field.value !== selectedDate) {
        field.value = selectedDate;
        field.setCustomValidity('');
      }
    });
  }

  function validateDeliveryDate(field) {
    field.min = minimumDeliveryDate();
    field.setCustomValidity('');

    if (field.value && field.value < field.min) {
      field.setCustomValidity(
        'Escolha uma data a partir de amanhã.'
      );
    }

    return field.reportValidity();
  }

  function showStatus(message) {
    document.querySelectorAll(selector).forEach((field) => {
      const container = field.closest('.delivery-date');
      if (!container) return;

      let status = container.querySelector('[data-date-status]');

      if (!status) {
        status = document.createElement('p');
        status.dataset.dateStatus = '';
        status.setAttribute('role', 'status');
        container.appendChild(status);
      }

      if (status.textContent !== message) {
        status.textContent = message;
      }
    });
  }

  function saveDate(value) {
    saveQueue = saveQueue.then(async () => {
      // Voltar a validar se entretanto mudou o dia.
      if (value && value < minimumDeliveryDate()) {
        saveFailed = true;
        showStatus('Escolha uma data a partir de amanhã.');
        return;
      }

      showStatus('A guardar a data…');

      try {
        const response = await fetch(`${root}cart/update.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            attributes: { [attribute]: value }
          })
        });

        if (!response.ok) {
          throw new Error('Save failed');
        }

        const cart = await response.json();

        if ((cart.attributes?.[attribute] || '') !== value) {
          throw new Error('Date not confirmed');
        }

        saveFailed = false;
        showStatus(value ? 'Data guardada.' : 'Data removida.');
      } catch (error) {
        saveFailed = true;
        showStatus(
          'Não foi possível guardar a data. Tente novamente antes de continuar.'
        );
      }
    });

    return saveQueue;
  }

  // Limpar o aviso anterior enquanto o cliente corrige a data.
  document.addEventListener('input', (event) => {
    if (!event.target.matches(selector)) return;

    event.target.setCustomValidity('');
    selectionVersion++;
  });

  document.addEventListener('change', (event) => {
    const field = event.target;
    if (!field.matches(selector)) return;

    selectionVersion++;

    if (!validateDeliveryDate(field)) return;

    selectedDate = field.value;
    syncFields();
    saveDate(selectedDate);
  });

  // Guardar e validar antes de avançar pelo botão do carrinho.
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    const button = event.submitter;

    if (!button || button.name !== 'checkout') return;
    if (!document.querySelector(selector)) return;

    if (allowedForms.has(form)) {
      allowedForms.delete(form);
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    const field = Array.from(
      document.querySelectorAll(selector)
    ).find((item) => item.form === form);

    if (!field) return;
    if (!validateDeliveryDate(field)) return;

    selectedDate = field.value;
    selectionVersion++;
    syncFields();

    const submittedDate = selectedDate;
    await saveDate(submittedDate);

    if (saveFailed) return;
    if (selectedDate !== submittedDate) return;
    if (!form.isConnected || !button.isConnected) return;
    if (!validateDeliveryDate(field)) return;

    allowedForms.add(form);
    form.requestSubmit(button);
  }, true);

  async function refreshSavedDate() {
    const requestNumber = ++refreshNumber;
    const versionAtStart = selectionVersion;
    const queueAtStart = saveQueue;

    await queueAtStart;

    if (saveFailed) return;
    if (selectionVersion !== versionAtStart) return;
    if (saveQueue !== queueAtStart) return;

    try {
      const response = await fetch(`${root}cart.js`, {
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      });

      if (!response.ok) {
        throw new Error('Cart read failed');
      }

      const cart = await response.json();

      // Não substituir uma escolha feita durante a consulta.
      if (requestNumber !== refreshNumber) return;
      if (selectionVersion !== versionAtStart) return;
      if (saveQueue !== queueAtStart) return;

      selectedDate = cart.attributes?.[attribute] || '';
      syncFields();

      if (
        selectedDate &&
        selectedDate < minimumDeliveryDate()
      ) {
        showStatus(
          'A data anteriormente escolhida já não está disponível. Escolha uma data a partir de amanhã ou deixe o campo vazio.'
        );
      }
    } catch (error) {
      showStatus(
        'Não foi possível atualizar a data guardada. Atualize a página para confirmar.'
      );
    }
  }

  syncFields();

  // Recuperar o valor quando o tema redesenha o carrinho.
  new MutationObserver(syncFields).observe(document.body, {
    childList: true,
    subtree: true
  });

  window.addEventListener('pageshow', refreshSavedDate);
  window.addEventListener('focus', refreshSavedDate);

  document.addEventListener('click', (event) => {
    if (event.target.closest('#cart-icon-bubble')) {
      refreshSavedDate();
    }
  });

  refreshSavedDate();
})();
